import React from "react";
import { ExpandedOverlay, ExpandedCard } from "./MaterialCarousel.styles";
import {
  getCardAtIndex,
  CAROUSEL_CARDS,
  EXPANDED_IMAGE_STYLE,
} from "./carouselShared";

interface ExpandedCardOverlayProps {
  expandedIndex: number | null;
  overlayShown: boolean;
  expandedCardRef: React.RefObject<HTMLDivElement>;
  firstRectRef: React.MutableRefObject<DOMRect | null>;
  lastRectRef: React.MutableRefObject<{
    left: number;
    top: number;
    width: number;
    height: number;
  } | null>;
  onClose: () => void;
  ExpandedOverlayComponent?: React.ComponentType<any>;
  ExpandedCardComponent?: React.ComponentType<any>;
}

const ExpandedCardOverlay: React.FC<ExpandedCardOverlayProps> = ({
  expandedIndex,
  overlayShown,
  expandedCardRef,
  firstRectRef,
  lastRectRef,
  onClose,
  ExpandedOverlayComponent,
  ExpandedCardComponent,
}) => {
  const OverlayComponent = ExpandedOverlayComponent || ExpandedOverlay;
  const CardComponent = ExpandedCardComponent || ExpandedCard;
  if (expandedIndex === null || !lastRectRef.current) return null;

  const expandedCard = getCardAtIndex(expandedIndex, CAROUSEL_CARDS);

  return (
    <OverlayComponent
      role="button"
      aria-label="Close expanded material"
      onClick={onClose}
      style={{
        backgroundColor: overlayShown
          ? "rgba(0, 0, 0, 0.45)"
          : "rgba(0, 0, 0, 0)",
        backdropFilter: overlayShown ? "blur(6px)" : "blur(0px)",
        WebkitBackdropFilter: overlayShown ? "blur(6px)" : "blur(0px)",
        transition: "background-color 600ms ease, backdrop-filter 600ms ease",
      }}
    >
      <CardComponent
        ref={expandedCardRef}
        role="dialog"
        aria-modal="true"
        style={{
          // Start with FIRST rect if available to avoid visual jump; will be adjusted in RAF
          width: `${
            firstRectRef.current?.width ?? lastRectRef.current.width
          }px`,
          height: `${
            firstRectRef.current?.height ?? lastRectRef.current.height
          }px`,
          left: `${firstRectRef.current?.left ?? lastRectRef.current.left}px`,
          top: `${firstRectRef.current?.top ?? lastRectRef.current.top}px`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={expandedCard.front}
          alt={expandedCard.alt}
          style={EXPANDED_IMAGE_STYLE}
        />
      </CardComponent>
    </OverlayComponent>
  );
};

export default ExpandedCardOverlay;
